import { Typography } from 'enable-ui';

import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';

export const WarningNoDefault = () => {
  return (
    <div
      style={{
        display: 'flex',
        background: '#FFF7E6',
        border: '1px solid #FFD59E',
        borderRadius: 12,
        padding: '9px 10px',
        marginBottom: 16,
      }}
    >
      <WarningIcon style={{ marginTop: 4 }} />
      <Typography style={{ fontSize: '18px', lineHeight: '26px', marginLeft: 8, color: '#FA8C16' }}>
        There is no default baseline fitness test. As a result, Trainers will be unable to start
        baseline fitness tests on the mobile app.
      </Typography>
    </div>
  );
};
